module.exports = __webpack_public_path__ + "static/media/bone_club.0326c451.png";